<template>
  <div class="store-credit-container">
    <div class="main">
      <div>{{ data.combine_name || '--' }}</div>
      <div v-if="userAuth.can_store_customer_combine" class="handle" @click="handelClick"><i class="el-icon-edit"/>
      </div>
    </div>
    <el-dialog :title="`「${data.name}」的集团`" :visible.sync="dialogCombine" width="420px" center append-to-body>
      <el-select v-model="combine_name" filterable default-first-option remote clearable
                 :remote-method="handelRemoteCombine"
                 placeholder="请选择集团" style="width: 100%">
        <el-option v-for="item in combineOptions" :key="item.id" :label="item.name" :value="item.id"/>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogCombine = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="handelSubmit" size="mini">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {storeCombine} from "@/api/customers";
import {combineCustomerLikeQuery} from "@/api/combine";

export default {
  name: "StoreCombine",
  props: {
    // {id: null, name: null, combine_name: null}
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialogCombine: false,
      combineOptions: [],
      combine_name: null,
    }
  },
  watch: {
    "data.combine_name"(_) {
      this.combine_name = _
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  mounted() {
    this.combine_name = this.data.combine_name
  },
  methods: {
    async handelRemoteCombine(query) {
      const response = await combineCustomerLikeQuery({value: query})
      this.combineOptions = response.model || []
    },
    async handelSubmit() {
      const _this = this;
      const response = await storeCombine({id: _this.data.id, combine_name: _this.combine_name});
      if (!response.success) {
        _this.showToast({h: _this, icon: "el-icon-error", text: response.message, duration: 2000});
        return false;
      }
      _this.$emit('success')
      _this.showToast({h: _this, icon: "el-icon-success", text: "操作成功", duration: 2000});
    },
    handelClick() {
      const _this = this;
      _this.dialogCombine = true;
    }
  }
}
</script>

<style lang="scss">
</style>